<template>
  <aha-modal
    @hide="$emit('closeThanksModal')"
    width="400px"
    :hideHeader="true"
    v-if="isThanksRequestModal"
    :no-margin-padding="true"
    :visible-overflow="true"
  >
    <div class="pl-6 pr-6 pt-6 pb-8 relative">
      <div class="flex flex-row justify-end align-middle pb-1.5 modal-close">
        <aha-icon
          name="close"
          @click="$emit('closeThanksModal')"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        />
      </div>
      <div class="font-16 font-bold">
        {{ $i18nPresenter.t('Thanks for your request!') }}
      </div>
      <img src="@/assets/images/ApproveThanksYour.png" class="mt-6 mb-4 w-full" />
      <div class="">
        {{ $i18nPresenter.t("We've received your request and will email you shortly.") }}
      </div>
      <div class="flex justify-end mt-4">
        <aha-button @click="$emit('closeThanksModal')">
          {{ $i18nPresenter.t('Done') }}
        </aha-button>
      </div>
    </div>
  </aha-modal>
</template>
<script >
export default {
  props: {
    isThanksRequestModal: {
      type: Boolean,
      default: false,
    },
  },

}
</script>
